import React from 'react';
import './SetupDisplay.css'

function  SetupDisplay () {
  
        return (
            <div>
     {/* <!-- HEADER --> */}
    <div className="pageHeader">

      <div className="pageHeaderLeft">

        <div className="pageTitle">
          Cấu hình hiển thị
        </div>

        <div className="breadcrumb">

          <span className="breadcrumbText">
            Trang chủ
          </span>

          <span>/</span>

          <span className="breadcrumbText">
            Cấu hình hệ thống
          </span>

          <span>/</span>

          <span className="breadcrumbActive">
            Cấu hình hiển thị
          </span>

        </div>

      </div>

      <button className="saveButtonDisplay">

        <i className="fa-solid fa-floppy-disk"></i>

        Lưu cấu hình

      </button>

    </div>

    {/* <!-- MAIN GRID --> */}
    <div className="mainGrid">

      {/* <!-- LEFT --> */}
      <div className="leftColumn">

        {/* <!-- GIAO DIỆN CHUNG --> */}
        <div className="sectionWrapper">

          <div className="sectionTitle">
            Giao diện chung
          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Chế độ giao diện
            </div>

            <div className="radioWrapper">

              <label className="radioItem">

                <input
                  type="radio"
                  name="theme"
                  checked
                  className="radioInput"
                />

                Sáng

              </label>

              <label className="radioItem">

                <input
                  type="radio"
                  name="theme"
                  className="radioInput"
                />

                Tối

              </label>

            </div>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Màu chủ đạo
            </div>

            <div className="colorWrapper">

              <div className="colorItem colorPurple colorItemActive"></div>

              <div className="colorItem colorGreen"></div>

              <div className="colorItem colorOrange"></div>

              <div className="colorItem colorRed"></div>

              <div className="colorItem colorBlue"></div>

            </div>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Kiểu menu
            </div>

            <select className="formSelectShare">

              <option>
                Menu dọc cố định
              </option>

            </select>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Hiệu ứng chuyển trang
            </div>

            <select className="formSelectShare">

              <option>
                Mờ dần
              </option>

            </select>

          </div>

        </div>

        {/* <!-- BẢNG DỮ LIỆU --> */}
        <div className="sectionWrapper">

          <div className="sectionTitle">
            Bảng dữ liệu
          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Số dòng mặc định trên mỗi trang
            </div>

            <select className="formSelectShare">

              <option>
                20
              </option>

            </select>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Cho phép thay đổi số dòng trên mỗi trang
            </div>

            <label className="switch">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Hiển thị số thứ tự
            </div>

            <label className="switch">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Hiển thị thanh công cụ bảng
            </div>

            <label className="switch">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Tự động lưu cấu hình cột
            </div>

            <label className="switch">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Hiển thị luân dòng (zebra)
            </div>

            <label className="switch">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Cố định tiêu đề bảng khi cuộn
            </div>

            <label className="switch">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

        </div>

        {/* <!-- PHÔNG CHỮ --> */}
        <div className="sectionWrapper">

          <div className="sectionTitle">
            Phông chữ
          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Phông chữ hệ thống
            </div>

            <select className="formSelectShare">

              <option>
                Inter
              </option>

            </select>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Kích thước chữ mặc định
            </div>

            <select className="formSelectShare">

              <option>
                14px
              </option>

            </select>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Kích thước chữ tiêu đề
            </div>

            <select className="formSelectShare">

              <option>
                18px
              </option>

            </select>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Kích thước chữ nhỏ
            </div>

            <select className="formSelectShare">

              <option>
                12px
              </option>

            </select>

          </div>

        </div>

      </div>

      {/* <!-- RIGHT --> */}
      <div className="rightColumn">

        {/* <!-- NGÔN NGỮ --> */}
        <div className="sectionWrapper">

          <div className="sectionTitle">
            Ngôn ngữ và định dạng
          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Ngôn ngữ hiển thị
            </div>

            <select className="formSelectShare distance-share">

              <option>
                Tiếng Việt
              </option>

            </select>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Định dạng ngày
            </div>

            <select className="formSelectShare distance-share">

              <option>
                dd/MM/yyyy
              </option>

            </select>

            <div className="exampleText distance-share">
              Ví dụ: 20/05/2024
            </div>

          </div>

          <div className="formRow">

            <div className="formLabelShare ">
              Định dạng giờ
            </div>

            <select className="formSelectShare distance-share">

              <option className='formSelectShare'>
                HH:mm:ss
              </option>

            </select>

            <div className="exampleText distance-share">
              Ví dụ: 14:30:15
            </div>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Định dạng số
            </div>

            <select className="formSelectShare distance-share">

              <option>
                1.234.567,89
              </option>

            </select>

            <div className="exampleText distance-share">
              Ví dụ: 1.234.567,89
            </div>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Đơn vị tiền tệ
            </div>

            <select className="formSelectShare distance-share">

              <option>
                VND (đ)
              </option>

            </select>

            <div className="exampleText distance-share">
              Ví dụ: 1.000.000 đ
            </div>

          </div>

        </div>

        {/* <!-- DASHBOARD --> */}
        <div className="sectionWrapper">

          <div className="sectionTitle">
            Hiển thị trang chủ (Dashboard)
          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Số lượng widget trên một hàng
            </div>

            <select className="formSelectShare distance">

              <option>
                4
              </option>

            </select>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Tự động làm mới dữ liệu
            </div>

            <label className="switch distance-share">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Chu kỳ làm mới
            </div>

            <select className="formSelectShare distance-share">

              <option className='distance-share'>
                5 phút
              </option>

            </select>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Hiển thị biểu đồ động
            </div>

            <label className="switch ">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Hiển thị tin nhắn hệ thống
            </div>

            <label className="switch ">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

        </div>

        {/* <!-- THÔNG BÁO --> */}
        <div className="sectionWrapper">

          <div className="sectionTitle">
            Thông báo hiển thị
          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Hiển thị thông báo thành công
            </div>

            <label className="switch">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Hiển thị thông báo cảnh báo
            </div>

            <label className="switch">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Hiển thị thông báo lỗi
            </div>

            <label className="switch">

              <input type="checkbox" checked />

              <span className="slider"></span>

            </label>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Thời gian tự động ẩn thông báo
            </div>

            <select className="formSelectShare distance">

              <option>
                5 giây
              </option>

            </select>

          </div>

          <div className="formRow">

            <div className="formLabelShare">
              Vị trí hiển thị thông báo
            </div>

            <select className="formSelectShare distance-share">

              <option>
                Góc phải trên
              </option>

            </select>

          </div>

        </div>

      </div>

    </div>
            </div>
        );
    
}

SetupDisplay.propTypes = {

};

export default SetupDisplay;